import React from "react";
import PropTypes from "prop-types";

import { processes } from "../../../utils/Helper";
import JournalEntry from "./JournalEntry";
import Transaction from "./Transaction";
import IO from "./IO";
import Order from "./Order";
import Offer from "./Offer";
import Trade from "./Trade";
import CorpEvent from "./CorpEvent";
import Invoice from "./Invoice";
import SupplierInvoice from "./SupplierInvoice";
import InvoicePayment from "./InvoicePayment";
import SettleInst from "./SettleInst";
import EarningRecovery from "./EarningRecovery";
import ProvisionsPayment from "./ProvisionsPayment";
import Amortization from "./Amortization";
import RecurringCommissions from "./RecurringCommissions";
import RecCommissionsAccount from "./RecurringCommissions/RecCommissionAccount";
import CustomCorpEvent from "./CustomCorpEvent";
import CustodyLock from "./CustodyLock";
import ShortCover from "./ShortCover";
import InvoiceRequest from "./InvoiceRequest";

const CrossRefForms = ({ process, info, userType, platformRole, services, opsViewAccountName }) => {
  const renderForm = () => {
    switch (process) {
      case processes.DERIVATIVE_MATURITY:
        return
      case processes.JOURNAL_ENTRY:
        return <JournalEntry journalEntry={info} userType={userType} opsViewAccountName={opsViewAccountName}/>;
      case processes.TRANSACTION:
        return <Transaction transaction={info} />;
      case processes.EARNING_RECOVERY:
        return <EarningRecovery earning={info} />;
      case processes.PROVISIONS_PAYMENT:
        return <ProvisionsPayment payment={info} />;
      case processes.AMORTIZATION:
        return <Amortization payment={info} />;
      case processes.BULK_DEPOSIT:
      case processes.DEPOSIT:
      case processes.WITHDRAW:
      case processes.BULK_WITHDRAW:
      case processes.TRANSFER:
      case processes.WITHDRAW_ACCOUNT:
      case processes.DEPOSIT_ACCOUNT:
        return <IO io={info} userType={userType} services={services.io || {}} />;
      case processes.ORDER:
      case processes.BULK_ORDER:
      case processes.BASKET_ORDER:
        return <Order order={info} userType={userType} platformRole={platformRole} imageSource={"img/logo-symbol.png"} services={services.order || {}} opsViewAccountName={opsViewAccountName}/>;
      case processes.OFFER:
        return <Offer order={info} userType={userType} services={services.order || {}} />;
      case processes.TRADE:
        return <Trade trade={info} opsViewAccountName={opsViewAccountName}/>;
      case processes.CORP_EVENT:
        return <CorpEvent corpEvent={info} />;
      case processes.INVOICE:
        return <Invoice invoiceInfo={info} opsViewAccountName={opsViewAccountName}/>;
      case processes.SUPPLIER_INVOICE:
        return <SupplierInvoice invoiceInfo={info} />;
      case processes.INVOICE_PAYMENT:
        return <InvoicePayment payment={info} />;
      case processes.SETTLEMENT_INSTRUCTION:
        return <SettleInst settleInst={info} />;
      case processes.RECURRINGCOMMISSIONS:
        return <RecurringCommissions recurringCommission={info} />;
      case processes.RECCOMMISSIONACCOUNT:
        return <RecCommissionsAccount account={info} />;
      case processes.CUSTOM_EVENT:
        return <CustomCorpEvent info={info} />;
      case processes.CUSTODY_LOCK:
        return <CustodyLock info={info} />;
      case processes.SHORT_COVER:
        return <ShortCover info={info} />;
      case processes.INVOICE_REQUEST:
        return <InvoiceRequest invoiceRequest={info} services={services} />;
      default:
        return <h5>Invalid Process</h5>;
    }
  };

  return <React.Fragment>{renderForm()}</React.Fragment>;
};

CrossRefForms.propTypes = {
  process: PropTypes.string.isRequired,
  info: PropTypes.object.isRequired,
  userType: PropTypes.string.isRequired,
  services: PropTypes.object.isRequired,
};

export default CrossRefForms;
